import { invert } from 'lodash';

export const ENTITY = {
    PUSH_API: 'PUSH_API',
};

export const ENTITY_TO_PATH_MAP = {
    [ENTITY.PUSH_API]: 'pushapi',
};

export const PATH_TO_ENTITY_MAP = invert(ENTITY_TO_PATH_MAP);
